import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { TextArea } from '@tesla/informed-tds';
import { number } from 'prop-types';
import style from './style.module.scss';
import messages from './messages';

const TextAreaWithCounter = ({ maxLength, ...props }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const [textLength, setTextLength] = useState(maxLength);

  const handleChange = (e) => {
    const text = e.value || '';
    setTextLength(maxLength - text.length);
  };

  return (
    <div className={style.TextArea}>
      <TextArea
        {...props}
        maxLength={maxLength}
        onChange={handleChange}
        helper={formatMessage(messages.CharactersRemainingMessage, { counter: textLength })}
      />
    </div>
  );
};

TextAreaWithCounter.propTypes = {
  maxLength: number,
};

TextAreaWithCounter.defaultProps = {
  maxLength: 2500,
};

export default TextAreaWithCounter;
